import { configRefs } from "../../../utils/constants/config";

const LOGIN_PROVIDER = "gu-unic";

export function getLoginUrl(): string {
  return (
    `${configRefs.apis.loginconnector.dangerouslyAssertSyncValue()}/Navigator/Navigator` +
    `?clientWebSite=${LOGIN_PROVIDER}` +
    `&clientWsSuccessUrl=${window.location.href}` +
    `&clientWsFailureUrl=${window.location.href}` +
    `&forceLogin=true`
  );
}

export function getLogoutUrl(): string {
  return (
    `${configRefs.apis.loginconnector.dangerouslyAssertSyncValue()}/Navigator/Logout` +
    `?clientWebSite=${LOGIN_PROVIDER}` +
    `&logoutSuccessUrl=${window.location.href}`
  );
}
